import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { GetUserProfile } from "../../../utilities/api/auth/auth-service";
import { UserDatailsType, UserRoleType } from "../../../utilities/types";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

const initialState = {
    isLoggedIn: false,
    message: "",
    UserProfileDetails: {} as UserDatailsType,
    UserRole: {} as UserRoleType ,
    profileErrorMessage: {} as ErrorMessageType,

}

export const GetProfile = createAsyncThunk("UserProfile/GetProfile", () => GetUserProfile())

const ProfileDetailSlice = createSlice({
    name: "UserProfile",
    initialState,
    reducers: {
        resetProfileDetailSlice: () => initialState
    },
    extraReducers: (builder) => {
        builder

            .addCase(GetProfile.fulfilled, (state, action: PayloadAction<any>) => {
                if (action.payload.statusCode === 200) {
                    let data = action.payload.data
                    state.message = action.payload.data.message
                    state.UserProfileDetails = {
                        aadharNumber: data.aadharNumber,
                        addressId: data.addressId,
                        birthDate: data.birthDate,
                        countryCode: data.countryCode,
                        createdAt: data.createdAt,
                        email: data.email,
                        firstName: data.firstName,
                        gender: data.gender,
                        lastName: data.lastName,
                        phone: data.phone,
                        userImage: data.userImage,
                        defaultFacility: data.defaultFacility,
                        isPasswordReset: data.isPasswordReset,
                        addressLine1: data.address.addressLine1,
                        addressLine2: data.address.addressLine2,
                        city: data.address.city,
                        state: data.address.state,
                        country: data.address.country,
                        pincode: data.address.pincode,
                        landmark: data.address.landmark,
                        availableRewardPoints: data?.availableRewardPoints,
                        usedRewardPoints: data?.usedRewardPoints,
                        totalPlayedSports: data?.totalPlayedSports,
                    }
                    state.UserRole = data.userRole
                }
                else {
                    state.message = action.payload.response.data.message
                }
            })

        .addCase(GetProfile.rejected, (state, action) => {
            state.profileErrorMessage = { message: messages.error.internal_server_error };
        });
        
    }
})

export default ProfileDetailSlice.reducer
export const { resetProfileDetailSlice } = ProfileDetailSlice.actions
